<template>
  <div class="collapse-layout"
       :style="themeVars">
    <slot name="extra"
          :toggle="toggle"></slot>
    <div class="reference">
      <el-collapse-transition>
        <div class="target"
             v-show="!collapsed">
          <slot :toggle="toggle"></slot>
        </div>
      </el-collapse-transition>
      <slot name="trigger"
            :toggle="toggle">
        <div :class="['trigger', {'collapsed': collapsed}]">
          <div class="holder">
            <el-button size="mini"
                       type="text"
                       @click="toggle">
              <template v-if="collapsed">
                <span>展开更多</span>
                <i class="el-icon-arrow-down"></i>
              </template>
              <template v-else>
                <span>隐藏更多</span>
                <i class="el-icon-arrow-up"></i>
              </template>
            </el-button>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import Theme from '../../../mixins/theme'
export default {
  name: 'CollapseLayout',
  mixins: [Theme],
  props: {
    defaultCollapsed: Boolean
  },
  data () {
    return {
      collapsed: this.defaultCollapsed
    }
  },
  methods: {
    toggle () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss">
  .collapse-layout {
    &:hover {
      & > .reference {
        & > .trigger {
          opacity: 1;
          &:before {
            opacity: .2;
          }
        }
      }
    }
    & > .reference {
      position: relative;
      & > .trigger {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        opacity: 0;
        transition: all .3s;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background-image: linear-gradient(to top, var(--theme-color) 10%, rgba(255,255,255,0) 100%);
          background-position: top center;
          background-repeat: no-repeat;
          border-radius: 25% 25% 0 0;
          pointer-events: none;
          opacity: 0;
          transition: all .3s;
        }
        & > .holder {
          position: relative;
          .el-button {
            width: 100%;
            font-weight: bold;
            i {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>
